export const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
  "Accept": "application/json",
} as const;

export const METHOD_EXECUTION_FAIL = "MethodExecutionFail" as const;
export const UNAUTHORIZED_STATUS = 401 as const;
